import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { LoadingController, ToastController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';
import { presentLoader } from 'src/app/util/ion-util';
import { Logger } from 'src/app/util/logger/logger.service';
import { UserService as CmbUserApi} from '@bluecrew/crew-member-backend-angular-client';

@Component({
  selector: 'app-delete',
  templateUrl: './delete.component.html',
  styleUrls: ['./delete.component.scss'],
})
export class DeleteComponent implements OnInit {

  form: UntypedFormGroup;

  constructor(private readonly cmbUserApi: CmbUserApi,
              private readonly formBuilder: FormBuilder,
              private readonly loadingCtrl: LoadingController,
              private readonly logger: Logger,
              private readonly toastCtrl: ToastController,
              private readonly userService: UserService) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      // case insensitive 'delete', the trailing 'i' denotes case insensitive
      delete: new FormControl<string>('', [Validators.compose([Validators.required, Validators.pattern(/delete/i)])]),
    });
  }

  async onSubmit() {
    if (this.form.valid) {
      const loader = await presentLoader(this.loadingCtrl);
      await this.cmbUserApi.deleteUser()
        .toPromise()
        .then(async () => {
          await loader.dismiss();
          const toastMessage = '<img src="assets/icons/completed-check.svg"></img>Account deletion initiated';
          this.presentToast(toastMessage, true);
          this.userService.logout();
        }).catch(async (err) => {
          let toastMessage: string;
          if (err?.error?.reason === 'AlreadyDeleted') {
            toastMessage = '<img src="assets/icons/alert-triangle.svg"></img> You have previously initiated deletion for this account. Please allow up to 2 weeks for this process to be complete'
          } else {
            toastMessage = '<img src="assets/icons/alert-triangle.svg"></img> Something went wrong. Please try again';
          }
          await loader.dismiss();
          this.logger.error(err);
          await this.presentToast(toastMessage, false);
        });
    }
  }

  async presentToast(message: string, isSuccess: boolean = false) {
    // Stop multiple toasts
    try {
      await this.toastCtrl.dismiss();
    } catch(err) {}
    let toast = await this.toastCtrl.create({
      cssClass: isSuccess ? 'success-toast' : 'error-toast',
      message: message,
      duration: 1500,
      position: 'bottom',
    });
    toast.present();
  }
}
